import ActionButton from "../atoms/ActionButton";

// YYYYMMDD → YYYY/MM/DD に変換して表示用にする
const formatDateDisplay = (yyyymmdd) =>
  `${yyyymmdd.slice(0, 4)}/${yyyymmdd.slice(4, 6)}/${yyyymmdd.slice(6, 8)}`;

// セルの値を CSV 安全な文字列に変換する
const escapeCsvCell = (val) => {
  const s = String(val ?? "");
  return s.includes(",") || s.includes("\n") || s.includes('"')
    ? `"${s.replace(/"/g, '""')}"`
    : s;
};

const CSV_HEADER = ["日付", "店舗番号", "店舗名", "レジ番号", "レジ名", "担当者名", "メッセージ内容"];

/**
 * CommentCsvDownload - コメント一覧 CSV ダウンロードボタン
 *
 * Message が空でない行のみを月単位・全店舗1ファイルにまとめてダウンロードする。
 *
 * @param {object[]} regiInfo  - 全レジ情報 [{ShopNo, ShopName, RegiNo, RegiName}]
 * @param {object[]} reports   - 表示中の月の全店舗データ [{YYYYMMDD, ShopNo, RegiNo, Message, ...}]
 * @param {string}   yearMonth - 対象年月 (YYYYMM形式・ファイル名に使用)
 * @param {boolean}  disabled  - ボタン非活性フラグ
 */
function CommentCsvDownload({ regiInfo, reports, yearMonth, disabled }) {
  const handleDownload = () => {
    const commentRows = reports
      .filter((r) => r.Message && r.Message.trim() !== "")
      .sort((a, b) =>
        a.YYYYMMDD !== b.YYYYMMDD
          ? a.YYYYMMDD.localeCompare(b.YYYYMMDD)
          : a.ShopNo - b.ShopNo || a.RegiNo - b.RegiNo
      );

    const dataRows = commentRows.map((row) => {
      const regi = regiInfo.find(
        (r) => String(r.ShopNo) === String(row.ShopNo) && String(r.RegiNo) === String(row.RegiNo)
      );
      return [
        formatDateDisplay(row.YYYYMMDD),
        row.ShopNo,
        row.ShopName ?? regi?.ShopName ?? "",
        row.RegiNo,
        regi?.RegiName ?? "",
        row.UpdatePerson ?? row.InputPerson ?? "",
        row.Message,
      ]
        .map(escapeCsvCell)
        .join(",");
    });

    const bom = "﻿";
    const csvContent = bom + [CSV_HEADER.join(","), ...dataRows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${yearMonth}_コメント一覧.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <ActionButton
      label="コメントCSVダウンロード"
      onClick={handleDownload}
      disabled={disabled}
      paddingClass="px-4 py-2"
      textSizeClass="text-base"
    />
  );
}

export default CommentCsvDownload;
